import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";

import { Navbar } from "../../modules/ui/Navbar";
import {
    Box,
    Button,
    Container,
    CssBaseline,
    Divider,
    Grid,
    Stack,
    ThemeProvider,
    Typography,
    createTheme,
} from "@mui/material";
import { MuiDatePicker } from "../../modules/ui/MuiDatePicker";
import MUIDataTable from "mui-datatables";
import { deleteById, getAllFromRegistroGeneral } from "../../../database/dbRegistroGeneral";
import { getAllFromEduconCursosRegistrados } from "../../../database/dbEduconCursosRegistrados";
import { getAllIn } from "../../../services/crudCustom";
import { getEmpleados } from "../../../database/dbEmpleados";



const columnOptions = {
    customBodyRender: val => <div style={{ width: "140px" }}>{ val }</div>
};

const textLabels = {
    body: {
        noMatch: "Ingresar datos",
        toolTip: "Ordenar",
        columnHeaderTooltip: column => `Ordenar por ${column.label}`
    },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Renglones por página:",
        displayRows: "de",
    },
    toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Mostrar Columnas",
        filterTable: "Filtrar tabla",
    },
    filter: {
        all: "Todo",
        title: "FILTROS",
        reset: "RESETEAR",
    },
    viewColumns: {
      title: "Mostrar Columnas",
    //   titleAria: "Show/Hide Table Columns",
    },
};

const educonsOptions = {
    print: false,
    search: false,
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "460px",
    selectableRows: "none",
    rowsPerPage: 30,
    rowsPerPageOptions: [30, 60, 100],

    //* Necesario para que soporte caracteres especiales (special characters) en la descarga
    onDownload: (buildHead, buildBody, columns, data) => {
        return "\uFEFF" + buildHead(columns) + buildBody(data); 
    },

    textLabels: textLabels,
};
const educonsColumns = [
    { name: "nombre",
        label: "Nombre",
        options: {
            filter: true,
            sort: true,
            setCellProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: "0",
                    background: "whitesmoke",
                    fontWeight: 600,
                    zIndex: 100, 
                },
            }),
            setCellHeaderProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: 0,
                    background: "white",
                    fontWeight: 600,
                    textAlign: "center",
                    zIndex: 101,
                },
            }),
            customBodyRender: val => {
                let cellStyle = {
                  boxSizing: "border-box",
                  overflow: "scroll",
                //   textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "600px"
                };
                return (
                  <div style={{ position: "relative", height: "20px", width: "600px" }}>
                      <div style={ cellStyle }>{ val }</div>
                  </div>
                );
            }
        },
    },
    { name: "responsableNombreCompleto", 
        label: "Responsable", 
        options: {
            customBodyRender: val => {
                return (
                    <div style={{ width: "280px" }}>{ val }</div>
                );
            }
        }
    },
    { name: "fechaSolicitud", label: "Solicitud", 
        options: {
            customBodyRender: (value) => (
                <div style={{ width: '80px' }}>
                    { `${value.substring(0,4)}-${value.substring(5,7)}-${value.substring(8,10)}` }
                </div>
            )
        }
    },
    { name: "fechaInicio", label: "Inicio", 
        options: {
            customBodyRender: (value) => (
                <div style={{ width: '80px' }}>
                    { `${value.substring(0,4)}-${value.substring(5,7)}-${value.substring(8,10)}` }
                </div>
            )
        }
    },
    { name: "fechaFin", label: "Termino", 
        options: {
            customBodyRender: (value) => (
                <div style={{ width: '80px' }}>
                    { `${value.substring(0,4)}-${value.substring(5,7)}-${value.substring(8,10)}` }
                </div>
            )
        }
    },
    { name: "cve_Proyec", label: "Proyecto", 
        options: {
            customBodyRender: (value) => (
                <span>
                    { value === '0' ? `No aplica` : value }
                </span>
            )
        }
    },
    { name: "modalidad", label: "Modalidad", },
];



export const Dashboard = () => {

    const cookies = new Cookies();
    const cookieId = cookies.get('id');

    const [empleados, setEmpleados] = useState([]);

    const [formValues, setFormValues] = useState({
        startDate: new Date(`01/01/${ new Date().getFullYear() }`),
        // startDate: new Date(),
        endDate: new Date(),
    });

    const [isSendButtonDisabled, setIsSendButtonDisabled] = useState(false);

    const [educonsData, setEduconsData] = useState([]);

    const [reportData, setReportData] = useState([]);


    const reportOptions = {
        print: false,
        search: false,
        filter: true,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "460px",
        selectableRows: 'multiple',
        rowsPerPage: 30,
        rowsPerPageOptions: [30, 60, 100],

        //* Necesario para que soporte caracteres especiales (special characters) en la descarga
        onDownload: (buildHead, buildBody, columns, data) => {
            return "\uFEFF" + buildHead(columns) + buildBody(data); 
        },
        
        onRowsDelete: (rowsDeleted) => deleteRows(rowsDeleted),

        textLabels: textLabels,
    };
    const reportColumns = [
        { name: "registroReferencia",
            label: "Referencia",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "nowrap",
                        position: "sticky",
                        left: "0",
                        background: "whitesmoke",
                        fontWeight: 600,
                        zIndex: 100,
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        whiteSpace: "nowrap",
                        position: "sticky",
                        left: 0,
                        background: "white",
                        fontWeight: 600,
                        textAlign: "center",
                        zIndex: 101,
                    },
                }),
                customBodyRender: val => {
                    return (
                        <div>
                            <a 
                                href={ `${process.env.REACT_APP_HOMEPAGE}/visualizar-registro/${ val }` }
                                target='_blank'
                            >
                                { val }
                            </a>
                            {/* { val } */}
                        </div>
                    );
                }
            },
        },
        { name: "partNombres", label: "Nombres", options: columnOptions, },
        { name: "partApellidoPaterno", label: "Apellido Paterno", options: columnOptions, },
        { name: "partApellidoMaterno", label: "Apellido Materno", options: columnOptions, },
        { name: "partInstProcedencia", label: "Institución de Procedencia",  
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "nowrap",
                        left: "0",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        whiteSpace: "nowrap",
                        left: 0,
                        background: "white",
                        fontWeight: 600,
                        textAlign: "center",
                    },
                }),
                customBodyRender: val => {
                    let parentStyle = {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    boxSizing: "border-box",
                    display: "block",
                    width: "100%"
                    };
                    let cellStyle = {
                    boxSizing: "border-box",
                    overflow: "hidden",
                    // background: "white",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                    };
                    return (
                    <div style={{ position: "relative", height: "20px", width: "400px" }}>
                        <div style={ parentStyle }>
                        <div style={ cellStyle }>{ val }</div>
                        </div>
                    </div>
                    );
                }
            },
    },
        { name: "partEstatus", label: "Estatus", options: columnOptions, },
        { name: "partEdad", label: "Edad", },
        { name: "partGradoAcademico", label: "Grado Académico", options: columnOptions, },
        { name: "partSexo", label: "Sexo", },
        { name: "partNacionalidad", label: "Nacionalidad", },
        { name: "partTelefono", label: "Teléfono", },
        { name: "partEmail", label: "Email", },
        { name: "partLenguaIndigena", label: "Lengua Indígena", options: columnOptions, },
        { name: "partDiscapacidad", label: "Discapacidad", options: columnOptions, },
        { name: "educonDescripcion", label: "Tipo de actividad", options: columnOptions, },
        { name: "educonTitulo", 
            label: "Nombre de la actividad", 
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "nowrap",
                        left: "0",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        whiteSpace: "nowrap",
                        left: 0,
                        background: "white",
                        fontWeight: 600,
                        textAlign: "center",
                    },
                }),
                customBodyRender: val => {
                    let parentStyle = {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    boxSizing: "border-box",
                    display: "block",
                    width: "100%"
                    };
                    let cellStyle = {
                    boxSizing: "border-box",
                    overflow: "hidden",
                    //   background: "white",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                    };
                    return (
                    <div style={{ position: "relative", height: "20px", width: "400px" }}>
                        <div style={ parentStyle }>
                        <div style={ cellStyle }>{ val }</div>
                        </div>
                    </div>
                    );
                }
            },
        },
        { name: "educonLugar", label: "Lugar", options: columnOptions, },
        { name: "educonFechaInicio", label: "Fecha de Inicio", options: columnOptions, },
        { name: "educonFechaTermino", label: "Fecha de Termino", options: columnOptions, },
        { name: "educonDuracion", label: "Duración (horas)", options: columnOptions, },
    ];


    const deleteRows = async({ data }) => {
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const item = data[key];

                const record = reportData[item.dataIndex];
                console.log({record});

                const resultDelete = await deleteById(record.id);
                console.log({resultDelete});
            }
        }
    }

    const parseDateValue = (val) => {
        return val.substring(0, 10);
    }

    const parseDateTimeValue = (val) => {
        return `${ val.substring(0, 10) }, ${ val.substring(11, 19) } hrs.`;
    }

    function titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        return splitStr.join(' '); 
     }

    // Al modificar un dato en un input
    const handleInputDateChange = ({ target }) => {
        const { name, value } = target;

        setFormValues({
            ...formValues,
            [name]: value,
        });
    };



    //* Al presionar el boton "Consultar"
    const handleSubmit = async (event) => {
        event.preventDefault();

        setIsSendButtonDisabled(true);

        //* Cargar actividades (educons) desde la view proporcionada por el area de sistemas
        const { data: educonCursosRegistrados } = await getAllFromEduconCursosRegistrados();
        console.log({ educonCursosRegistrados });

        //* Filtrar las activities cuyo inicio y termino estan dentro del periodo indicado
        const educonCursosRegistradosByPeriod = [];
        educonCursosRegistrados.forEach(item => {
            const educonSolicitud = new Date(item.fechaSolicitud);
            if (educonSolicitud >= formValues.startDate && educonSolicitud <= formValues.endDate) {
                console.log({item});
                const emp = empleados.find(e => e.emailNormal === item.email);
                console.log({emp});
                item.responsableNombreCompleto = emp ? emp.nombreCompleto : '';
                educonCursosRegistradosByPeriod.push(item)
            };
        });
        //* Setear las activities que si cumplen el periodo y se van a mostrar en la tabla
        setEduconsData(educonCursosRegistradosByPeriod);
        console.log({educonCursosRegistradosByPeriod});

        //*
        //* Obtenemos todos los records de todas las activities en ambas tablas RegistroGeneral y Educon
        //*
        const { data: recordsRegistroGeneral } = await getAllFromRegistroGeneral();
        recordsRegistroGeneral.forEach(rrg => {
            const infoAdTmp = JSON.parse(rrg.infoAdicional);
            rrg.infoAdTmp = infoAdTmp;

            //! Valores que deben tener en comun
            rrg.educonFechaInicio = infoAdTmp.educonInicio;
            rrg._educonId = infoAdTmp.educonId;
        })
        console.log({ recordsRegistroGeneral });

        const { data: recordsEducon } = await getAllIn({ table: 'Educon' });
        recordsEducon.forEach(reE => {
            //! Valores que deben tener en comun
            reE.educonFechaInicio = reE.educonInicio;
            reE._educonId = Number(reE.educonId);
        })
        console.log({recordsEducon});

        //* Array donde se almancenaran todos los records
        let recordsSumarized = [];

        //* Construir array con los registros de los participantes de todas las activities
        educonCursosRegistradosByPeriod.forEach(actFBP => {
            // console.log(actFBP);
            const { folio, solicitudID, fechaInicio } = actFBP;
            // console.log(solicitudID);


            //* Para 'RegistroGeneral', filtramos los records por solicitudID y aplicamos el concat al array
            const recordsFiltered = recordsRegistroGeneral.filter(r => r._educonId === folio);
            // console.log({recordsFiltered});

            recordsFiltered.forEach(rf => {
                rf._descripcion = actFBP.descripcion;
                rf._fechaInicio = actFBP.fechaInicio.slice(0, 10);
                rf._fechaFin = actFBP.fechaFin.slice(0, 10);
                rf._duracionHoras = actFBP.duracionHoras;
            });
            recordsSumarized = recordsSumarized.concat(recordsFiltered);
            

            //* Para 'Educon', filtramos los records que tengan por solicitudID y aplicamos push para cada elemento
            const recordsEduconFiltered = recordsEducon.filter(re => re._educonId === folio);
            // console.log({recordsEduconFiltered});
            recordsEduconFiltered.forEach(rEdF => {

                const infoAdTmp = {
                    educonTitulo: rEdF.educonTitulo, 
                }
                // Construir elemento a agregar
                const itemTmp = {
                    id: rEdF.id,
                    partApellidoPaterno: rEdF.partApellidoPaterno,
                    partApellidoMaterno: rEdF.partApellidoMaterno,
                    partNombres: rEdF.partNombres,
                    partCorreo: rEdF.partCorreo,
                    partPais: rEdF.partPais,
                    partEstado: rEdF.partEstado,
                    tipoRegistro: rEdF.tipoRegistro,
                    tipoRegistroDocURL: `https://eventos.cibnor.mx/registro/apiServiciosSIARF/UploadFiles/${ rEdF.refBancaria }_credencial.pdf`,
                    registroClaveProyecto: rEdF.claveProyRec,
                    registroFecha: rEdF.fechaRegistro,
                    registroReferencia: rEdF.refBancaria,
                    infoAdicional: JSON.stringify(infoAdTmp),
                    _descripcion: actFBP.descripcion,
                    _fechaInicio: actFBP.fechaInicio.slice(0, 10),
                    _fechaFin: actFBP.fechaFin.slice(0, 10),
                    _duracionHoras: actFBP.duracionHoras,
                }
                // Agregamos el item al array
                recordsSumarized.push(itemTmp);
            })
        })
        
        console.log({recordsSumarized});

        //* Para cada registro de participante hay que construir el objeto a insertar en el recordsToShow
        let recordsToShow = [];
        recordsSumarized.forEach(record => {
            // console.log({record});
            const infoAdicional = JSON.parse(record.infoAdicional);
            // console.log({infoAdicional});
            const { partInstProcedencia, partEdad, partGradoAcademico, partSexo, partTelefono, partLenguaIndigena, partDiscapacidad, educonTitulo, educonModalidad } = infoAdicional;
            // Inicializamos el record a insertar
            const recordToPush = {
                id: record.id,
                registroReferencia: record.registroReferencia || '-',
                partNombres: record.partNombres || '-',
                partApellidoPaterno: record.partApellidoPaterno || '-',
                partApellidoMaterno: record.partApellidoMaterno || '-',
                partInstProcedencia: partInstProcedencia || '-',
                partEstatus: record.tipoRegistro || '-',
                partEdad: partEdad || '-',
                partGradoAcademico: partGradoAcademico || '-',
                partSexo: partSexo || '-',
                partNacionalidad: record.partPais || '-',
                partTelefono: partTelefono || '-',
                partEmail: record.partCorreo || '-',
                partLenguaIndigena: partLenguaIndigena || '-',
                partDiscapacidad: partDiscapacidad || '-',
                educonDescripcion: record._descripcion || '-',
                educonTitulo: educonTitulo || '-',
                educonLugar: educonModalidad || '-',
                educonFechaInicio: record._fechaInicio || '-',
                educonFechaTermino: record._fechaFin || '-',
                educonDuracion: record._duracionHoras || '-',
            }
            recordsToShow.push(recordToPush);
        })

        setReportData(recordsToShow);

        setIsSendButtonDisabled(false);
    };


    useEffect(() => {
        const getEmpleadosFromDB = async() => {
            const { data } = await getEmpleados();
            setEmpleados(data);
        }
        getEmpleadosFromDB();

        document.title = "Dashboard EDUCON";
        // Si no ha iniciado sesion, redirigir
        if (!cookieId ) {
            window.location.replace('../sign-in?p=educon/dashboard');
        }
    }, [ cookieId ])
    


    return (
        <>
            <Navbar nombre={cookies.get("nombre")} />
            <ThemeProvider theme={createTheme()}>
                <Container component="main">
                    <CssBaseline />

                    <Grid container spacing={1} sx={{ p: 2 }}  maxWidth="xl" >
                        <Box display="flex" flexDirection="row" flex={1}>
                            <Grid item xs={12}>
                                <Typography variant="h4">
                                    Dashboard EDUCON
                                </Typography>
                                <Typography variant="title1">
                                    Reporte general
                                </Typography>
                            </Grid>
                        </Box>
                        <Box
                            autoComplete="off"
                            component="form"
                            display="flex"
                            flexDirection="row"
                            onSubmit={handleSubmit}
                            noValidate
                            sx={{ mt: 2 }}
                        >
                            <MuiDatePicker
                                name="startDate"
                                initialDate={ formValues.startDate }
                                label="Inicio"
                                parentCallback={handleInputDateChange}
                            />

                            <Divider orientation="vertical" flexItem>
                                hasta el
                            </Divider>

                            <MuiDatePicker
                                name="endDate"
                                label="fin del periodo"
                                parentCallback={handleInputDateChange}
                            />

                            <Box sx={{ mx: 1, my: "auto" }}>
                                <Button
                                    type="submit"
                                    disabled={ 
                                        (!formValues.startDate || !formValues.endDate) || 
                                        isSendButtonDisabled 
                                    }
                                    fullWidth
                                    variant="contained"
                                >
                                    Consultar
                                </Button>
                            </Box>
                        </Box>
                        <Grid item xs={12} >
                        </Grid>
                    </Grid>

                    {
                        educonsData.length > 0
                        ? (
                            <>
                                <Stack direction="column" marginTop={ 1 }>
                                    <MUIDataTable
                                        title={ "EDUCONS" }
                                        data={ educonsData }
                                        columns={ educonsColumns }
                                        options={ educonsOptions }
                                    />
                                </Stack>
        
                                <Stack direction="column" marginTop={ 1 } marginBottom={ 6 }>
                                    <MUIDataTable
                                        title={ "Registros de participantes" }
                                        data={ reportData }
                                        columns={ reportColumns }
                                        options={ reportOptions }
                                    />
                                </Stack>
                            </>
                        )
                        : (
                            <Box display="flex" flexDirection="row" sx={{ mt: 4 }} >
                                <Typography variant="h3">
                                    Ingresa el periodo para ver resultados.
                                </Typography>
                            </Box>
                        )
                    }

                </Container>
            </ThemeProvider>
        </>
    );
};
